export const nonprofitRouteNames = [
  'nonprofitDashboard', 'nonprofitEvents', 'nonprofitDonations', 'nonprofitEmployees',
  // nonprofitSettingsRoutes
  'nonprofitSettings', 'nonprofitSettingsDonations',
  // accountSettingsRoutes
  'nonprofitAccountSettings', 'nonprofitAccountSettingsPassword', 'nonprofitAccountSettingsNotifications',
]
